module.exports = __webpack_public_path__ + "media/images/lb/264-379c628290adaf7b81cedb4a0075457f.svg";